/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { setPolicyAgree } from '../../../../actions';
import { fromStore } from '../../../../selectors';

export function AgreePolicy() {
  const value = useSelector(fromStore.orderAgreeSelector);
  const createLoader = useSelector(fromStore.createOrderLoaderSelector);
  const user = useSelector(fromStore.userSelector);
  const dispatch = useDispatch();

  if (user && user.policyAgree) return null;

  const onChange = (e) => {
    dispatch(setPolicyAgree(e.target.checked));
  };

  return (
    <div className="d-flex align-items-center mt-2 mb-5">
      <span className="symbol symbol-20px me-2">
        <span className="form-check form-check-danger form-check-solid">
          <input
            className="form-check-input"
            type="checkbox"
            disabled={createLoader}
            onChange={onChange}
            checked={value.policyAgree}
          />
        </span>
      </span>
      <span className="fs-5 me-5">
        Я согласен с условиями <NavLink to="/policy" className="menu-link">Политики конфиденциальности </NavLink> <span style={{ color: 'red' }}>*</span>
      </span>
    </div>
  );
}
